import { useState, useEffect } from "react";
import { LAUNCH_DATE } from "../data/data";
import { Helmet } from "react-helmet";

const FLOAT_POSITIONS = [
  { top: "10%",    left:  "5%",   delay: "0s"   },
  { top: "20%",    right: "8%",   delay: "1.2s" },
  { bottom: "20%", left:  "10%",  delay: "2.1s" },
  { top: "60%",    right: "5%",   delay: "0.7s" },
  { bottom: "10%", right: "20%",  delay: "1.8s" },
];

export default function MenuPage() {
  const [time, setTime] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });
  const [notifyEmail, setNotifyEmail] = useState("");
  const [notified, setNotified] = useState(false);
  const [showNotify, setShowNotify] = useState(false);

  useEffect(() => {
    const tick = () => {
      const diff = LAUNCH_DATE - Date.now();
      if (diff <= 0) { setTime({ days: 0, hours: 0, minutes: 0, seconds: 0 }); return; }
      setTime({
        days:    Math.floor(diff / 86400000),
        hours:   Math.floor((diff % 86400000) / 3600000),
        minutes: Math.floor((diff % 3600000) / 60000),
        seconds: Math.floor((diff % 60000) / 1000),
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);

  const handleNotify = () => {
    if (notifyEmail.includes("@")) { setNotified(true); setShowNotify(false); }
  };

  return (
    <>
      <Helmet>
        <title>Menu | Millet Momos</title>
        <meta name="description" content="Explore our delicious millet momos menu in Hyderabad. Healthy, nutritious, and hygienic fast food." />
        <link rel="canonical" href="https://milletmomos.com/menu" />
      </Helmet>
    <section className="cs-section">
      <div className="floating-momos">
        {FLOAT_POSITIONS.map((p, i) => (
          <div key={i} className="float-momo" style={{ ...p, animationDelay: p.delay }}>🥟</div>
        ))}
      </div>

      <div className="cs-inner">
        <span className="cs-icon">🥟</span>
        <h1 className="cs-title">SOMETHING BIG IS COMING SOON</h1>
        <p className="cs-sub">OUR DELICIOUS MENU IS COOKING<span style={{ marginLeft: 8 }}>•••</span></p>
        <p className="cs-desc">
          We're perfecting our signature millet momos recipes! Get ready to experience the perfect blend of ancient grains and authentic flavors.{" "}
          <strong style={{ color: "var(--yellow)" }}>Guilt Kam Swad Full!</strong>
        </p>

        <div className="countdown">
          {[["days", "Days"], ["hours", "Hours"], ["minutes", "Minutes"], ["seconds", "Seconds"]].map(([k, l]) => (
            <div className="cd-box" key={k}>
              <span className="cd-num">{String(time[k]).padStart(2, "0")}</span>
              <span className="cd-label">{l}</span>
            </div>
          ))}
        </div>

        <div className="progress-wrap"><div className="progress-bar" /></div>
        <p className="progress-text">75% Complete — Almost Ready!</p>

        {!notified ? (
          <>
            {!showNotify ? (
              <button className="notify-btn" onClick={() => setShowNotify(true)}>🔔 Notify Me When It Launches</button>
            ) : (
              <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap", marginTop: "1rem" }}>
                <input
                  type="email"
                  placeholder="your@email.com"
                  value={notifyEmail}
                  onChange={e => setNotifyEmail(e.target.value)}
                  style={{ padding: ".9rem 1.4rem", borderRadius: "50px", border: "2px solid var(--yellow)", background: "rgba(255,255,255,.08)", color: "#fff", fontSize: "1rem", outline: "none", minWidth: "240px" }}
                />
                <button className="notify-btn" onClick={handleNotify}>Notify Me!</button>
              </div>
            )}
          </>
        ) : (
          <p style={{ color: "var(--yellow)", fontSize: "1.1rem", fontWeight: 600, marginTop: "1rem" }}>
            🎉 You're on the list! We'll notify you at {notifyEmail}
          </p>
        )}
      </div>
    </section>
<section className="menu-seo-section">
  <div className="menu-container">

    <h1>Millet Momos Menu in Hyderabad (Launching Soon)</h1>

    <p>
      Our healthy millet momos menu is launching soon in Hyderabad! We are preparing a delicious range of steamed, fried, and tandoori momos made with natural millets like ragi, jowar, and bajra.
    </p>

    <h2>What You Can Expect</h2>
    <ul className="menu-list">
      <li>🥟 Steamed Millet Veg Momos</li>
      <li>🥟 Chicken Millet Momos</li>
      <li>🔥 Tandoori Millet Momos</li>
      <li>🌶️ Spicy Millet Momos</li>
      <li>🧄 Garlic Millet Momos</li>
    </ul>

    <h2>Why Millet Momos?</h2>
    <p>
      Unlike regular momos made with maida, our millet momos are rich in fiber, protein, and essential nutrients. Perfect for health-conscious food lovers in Hyderabad.
    </p>

    <p style={{ marginTop: "20px", fontWeight: 600 }}>
      🚀 Stay tuned — we're launching very soon!
    </p>

  </div>
</section>
    </>
  );
}